import { render, staticRenderFns } from "./DeleteUserDataDialog.vue?vue&type=template&id=ba245900&scoped=true&"
import script from "./DeleteUserDataDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteUserDataDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteUserDataDialog.vue?vue&type=style&index=0&id=ba245900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba245900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VDivider,VIcon,VTextField})
